import React, { Component } from "react";
import "./index.css";

class GithubOverview extends Component {
  render() {
    return (
      <div
        className="github-stats-column h-100 p-3"
        style={{
          background: "var(--cardBg)",
          border: "var(--card-border)",
          transition: "color 0.2s ease-out, background 0.2s ease-out"
        }}
      >
        <div className="d-flex justify-content-between mb-3">
          <span className="badge badge-warning market-bedge">
            GitHub overview
          </span>
          <img
            className="img-fluid"
            src={require("../../../assets/icons/share-icon.svg")}
            alt="share"
          />
        </div>
        <h3
          className="github-stats-col-heading text-left"
          style={{
            color: "var(--h3Color)",
            transition: "color 0.2s ease-out, background 0.2s ease-out"
          }}
        >
          <span className="first-text">idni / tau</span>
          <span className="agoras-icon">
            <img
              className="img-fluid github-icon pl-2 pr-2"
              src={require("../../../assets/icons/github-icon.png")}
              style={{ filter: "var(--github-icon)" }}
              alt="Github"
            />
          </span>
        </h3>

        <div className="market-inner-col d-flex justify-content-between">
          <span
            className="currency-row"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            Sector : <span className="currency-text">Stats</span>
          </span>
          <span
            className="currency-row"
            style={{
              color: "var(--pDescColor)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            Category : <span className="currency-text">Development</span>
          </span>
        </div>

        <div className="row mt-5 ">
          <div className="col text-center">
            <h1
              className="github-stats-subheading"
              style={{ color: "var(--github-stats-subhead)" }}
            >
              75
            </h1>
            <img
              className="img-fluid ml-auto mr-auto"
              src={require("../../../assets/icons/star-icon.svg")}
              alt="Star-Icon"
              style={{ filter: "var(--github-icon)" }}
            />
            <p
              className="github-stats-body pt-2"
              style={{ color: "var(--github-stats-body)" }}
            >
              STARS
            </p>
          </div>

          <div className="col text-center">
            <h1
              className="github-stats-subheading"
              style={{ color: "var(--github-stats-subhead)" }}
            >
              37
            </h1>
            <img
              className="img-fluid ml-auto mr-auto"
              src={require("../../../assets/icons/watch-icon.svg")}
              alt="Watch-Icon"
              style={{ filter: "var(--github-icon)" }}
            />
            <p
              className="github-stats-body pt-2"
              style={{ color: "var(--github-stats-body)" }}
            >
              WATCHERS
            </p>
          </div>

          <div className="col text-center">
            <h1
              className="github-stats-subheading"
              style={{ color: "var(--github-stats-subhead)" }}
            >
              19
            </h1>
            <img
              className="img-fluid ml-auto mr-auto"
              src={require("../../../assets/icons/forks-icons.svg")}
              alt="Star-Icon"
              style={{ filter: "var(--github-icon)" }}
            />
            <p
              className="github-stats-body pt-2"
              style={{ color: "var(--github-stats-body)" }}
            >
              FORKS
            </p>
          </div>
        </div>

        <div className="row mt-5 ">
          <div className="col-4 text-center">
            <h1
              className="github-stats-subheading"
              style={{ color: "var(--github-stats-subhead)" }}
            >
              5
            </h1>
            <img
              className="img-fluid ml-auto mr-auto"
              src={require("../../../assets/icons/contributors-icon.svg")}
              alt="Star-Icon"
              style={{ filter: "var(--github-icon)" }}
            />
            <p
              className="github-stats-body pt-2"
              style={{ color: "var(--github-stats-body)" }}
            >
              CONTRIBUTE
            </p>
          </div>

          <div className="col-4 text-center">
            <h1
              className="github-stats-subheading"
              style={{ color: "var(--github-stats-subhead)" }}
            >
              21
            </h1>
            <img
              className="img-fluid ml-auto mr-auto"
              src={require("../../../assets/icons/pull-icon.svg")}
              alt="Star-Icon"
              style={{ filter: "var(--github-icon)" }}
            />
            <p
              className="github-stats-body pt-2"
              style={{ color: "var(--github-stats-body)" }}
            >
              MERGE PULL REQUESTS
            </p>
          </div>

          <div className="col-4 text-center">
            <h1
              className="github-stats-subheading"
              style={{ color: "var(--github-stats-subhead)" }}
            >
              0/0
            </h1>
            <img
              className="img-fluid ml-auto mr-auto"
              src={require("../../../assets/icons/closed-issues-icon.svg")}
              alt="Star-Icon"
              style={{ filter: "var(--github-icon)" }}
            />
            <p
              className="github-stats-body pt-2"
              style={{ color: "var(--github-stats-body)" }}
            >
              CLOSED ISSUES / TOTAL ISSUES
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default GithubOverview;
